import { Box } from "@mui/material";
import React from "react";
import { InputDate } from "controls";
import dayjs from "../utils/dayjs";
import { useTranslation } from "react-i18next";

const DateRange = ({ sortDate, setSortDate, className = "", error = "" }) => {
  const { t } = useTranslation();
  const handleDate = (name, newVal) => {
    setSortDate((x) => ({ ...x, [name]: newVal }));
  };

  return (
    <div>
      <Box
        className={`flex justify-center gap-2 items-center ${
          className || "w-full md:max-w-[380px]"
        }`}
      >
        <InputDate
          size="small"
          variant="outlined"
          name="fromDate"
          value={sortDate.fromDate}
          views={["day"]}
          openTo="day"
          minDate={new Date("01/01/2000")}
          maxDate={dayjs(sortDate.toDate).subtract(1, "day").toDate()}
          error={!!error}
          onChange={(date) =>
            handleDate("fromDate", date ? dayjs(date).format("MM/DD/YYYY") : "")
          }
        />
        <span>{t("to")}</span>
        <InputDate
          size="small"
          variant="outlined"
          name="toDate"
          value={sortDate.toDate}
          minDate={dayjs(sortDate.fromDate, "MM/DD/YYYY").add(1, "day").toDate()}
          views={["day"]}
          openTo="day"
          error={!!error}
          onChange={(date) =>
            handleDate("toDate", date ? dayjs(date).format("MM/DD/YYYY") : "")
          }
        />
      </Box>
      {error && (
        <span className="text-[14px] pl-[5px] text-red-500">{error}</span>
      )}
    </div>
  );
};

export default DateRange;
